import axios from "axios"
import Swal from "sweetalert2"

const {
    REACT_APP_GET_HOLD_PAYMENT_LIST_FILTERS: GET_HOLD_PAYMENT_LIST_FILTERS,
    REACT_APP_GET_HOLD_PAYMENT_LIST: GET_HOLD_PAYMENT_LIST
} = process.env

export const getHoldPaymentListFilters = async({ signal, params }) => {
    try {
        const query = new URLSearchParams(params).toString()

        const { data } = await axios.get(`${GET_HOLD_PAYMENT_LIST_FILTERS}?${query}`, { signal })

        return data
    } catch (error) {
        if (error.name === "AbortError") return

        console.error("Error fetching filters data:", error)
    }
}

export const getHoldPaymentList = async ({ params, signal }) => {
    try {
        Swal.fire({
            footer: 'Loading, please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        
        const { industry, location, ...rest } = params

        const query = new URLSearchParams(rest)

        if (industry?.length > 0) industry.forEach(i => query.append('industry[]', i))

        if (location?.length > 0) location.forEach(l => query.append('location[]', l))

        const { data } = await axios.get(`${GET_HOLD_PAYMENT_LIST}?${query.toString()}`, { signal })

        Swal.close()
        
        return data
    } catch (error) {
        if (error.name === "AbortError") return
                
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching hold payments.",
        })

        throw error.response?.data?.message
    }
}